<div mat-dialog-title class="dialog-info horizontal-padding m-0">
    <label class="dialogTitle">
        {{'REQUIRED_FIELD' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross" (click)="onCrossClick()"></button>
</div>

<mat-dialog-content class="p-0">
    <div class="row m-0 horizontal-padding">
        <div class="col-md-12 p-0">
            
            <p>{{'EXPORT_TO_PROPOSAL_REQUIRED_DIALOGBOX_DATA_1' | translate}}</p>
            <p>{{'EXPORT_TO_PROPOSAL_REQUIRED_DIALOGBOX_DATA_2' | translate}}</p>
            <div [formGroup]="requiredFieldForm" class="required-fields-form">
                <div class="form-row">
                    <label for="name" class="field-label">{{'NAME' | translate}}:</label>
                    <mat-form-field appearance="outline" class="field-input">
                        <input matInput id="name" formControlName="name">
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <label for="email" class="field-label">{{'EMAIL_ADDRESS' | translate}}:</label>
                    <mat-form-field appearance="outline" class="field-input">
                        <input matInput id="email" formControlName="email">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>        

<mat-dialog-actions align="end" class="dialog-actions-style">
    <div>
        <button class="openCloseBtn" mat-raised-button color="primary" (click)="onSubmit()">
            {{'COMMON_DIALOGS_BTN_LABELS_OK' | translate}}
        </button>
    </div>
</mat-dialog-actions>
